import styled from '@emotion/styled';
import { FC, FunctionComponent, ReactNode, SVGProps } from 'react';
import { theme } from '../../../theme';
import { CardHeaderContainer, Header } from '../SurveyCardComponents';

type SmallSurveyCardProps = {
  header: ReactNode;
  headerIcon: FunctionComponent<SVGProps<SVGSVGElement>>;
  results: ReactNode;
  footer: ReactNode;
  dataIcom?: string;
};

export const SmallSurveyCard: FC<SmallSurveyCardProps> = ({
  header,
  headerIcon: HeaderIcon,
  results,
  footer,
  dataIcom,
}) => {
  return (
    <StylesSurveyCard data-icom={dataIcom}>
      <StyledCardHeaderContainer>
        <HeaderIconWrapper>
          <HeaderIcon aria-hidden="true" />
        </HeaderIconWrapper>
        <Header>{header}</Header>
      </StyledCardHeaderContainer>
      {results && <Content>{results}</Content>}
      <Footer>{footer}</Footer>
    </StylesSurveyCard>
  );
};

const StylesSurveyCard = styled.div`
  width: 288px;
  background-color: ${theme.background.primary};
  border-radius: ${theme.borderRadius.m};
  box-shadow: 0px 10px 14px rgba(0, 0, 0, 0.01);
  padding: ${theme.spacing.g} 20px 20px 20px;
`;

const HeaderIconWrapper = styled.div`
  width: ${theme.spacing.g};
  height: ${theme.spacing.g};

  svg {
    width: 100%;
    height: 100%;
  }
`;

const StyledCardHeaderContainer = styled(CardHeaderContainer)`
  justify-content: center;
  padding-bottom: ${theme.spacing.e};
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 1rem;
`;
